<div class="header_search header_search_mobile">
  <div class="title-page">
    <h3>Demandas de Monitoramento</h3>
  </div>
  <div class="content_search">
    <div class="new-demand">
      <button class="btn-back" type="btn" (click)="mostrarCanceladas()">{{canceladas ? 'Ocultar' : 'Mostrar'}} Canceladas e Concluídas</button>
    </div>
    <div class="new-demand" *ngIf="canDemand">
      <a class="btn btn-primary" type="btn" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams()">Nova Demanda</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Código</th>
          <th>Item Monitorado</th>
          <th>Título</th>
          <th>Andamento</th>
          <th class="text-center">Status</th>
          <th class="text-center">Prazo</th>
          <th>Solicitante</th>
          <th>Atribuído para</th>
          <th class="text-center">Alterado em</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let demanda of demandasList; let i = index">
          <tr *ngIf="demanda?.issue_stat_name == 'Aberta' || canceladas">
            <td class="title text-center">{{ demanda?.id }}</td>
            <td>{{ demanda?.monitored_item }}</td>
            <td>{{ demanda?.subject }}</td>
            <td>{{ demanda?.issue_sub_stat_name }}</td>
            <td class="status">
              <div>
                <span [innerHTML]="demanda?.status1"></span>
                {{demanda?.issue_stat_name}}
              </div>
            </td>
            <td class="text-center">{{ demanda?.dt_foreseen_end }}</td>
            <td>{{ demanda?.demandant_name }}</td>
            <td>{{ demanda?.defendant_name }}</td>
            <td class="text-center">{{ demanda?.ctr_dth_atu }}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="viewDemanda(demanda?.id)" *ngIf="canDemand">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="demandasList?.length == 0" class="border-b-radius">
          <td colspan="10" class="text-center">Nenhum Demandas de Monitoramento Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>